// assets/assembly-add.js
document.addEventListener('DOMContentLoaded', () => {
    const form = document.querySelector('form[action^="/cart/add"]');
    if (!form) return;
  
    form.addEventListener('submit', async evt => {
      if (!window.IS_SALE_BIKE) return;
  
      evt.preventDefault();
      evt.stopImmediatePropagation();
  
      const fd = new FormData(form);
      const mainVariantId = fd.get('id');
      const mainQty       = parseInt(fd.get('quantity') || '1', 10);
  
      const items = [
        { id: mainVariantId,              quantity: mainQty },
        { id: window.ASSEMBLY_VARIANT_ID, quantity: 1       }
      ];
  
      try {
        const res = await fetch('/cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({ items })
        });
        if (res.ok) {
          window.location.href = '/cart';
        }
        // you can add UI error messaging here if you like
      } catch (err) {
        // optional: handle network errors here
      }
    }, true);
  });